import React from 'react';

import HighlightedText from '@marketing/components/highlighted_text';

import WallOfLoveSection from '../../../sections/wall_of_love';

import AybigeHeadshot from './assets/aybige_headshot.png';

export default (props) => {
  return (
    <WallOfLoveSection
      featuredQuote={{
        studentName: 'Aybige A.',
        studentAffiliation: null,
        content: (
          <>
            "Magoosh provided me with <HighlightedText color="#FCF0BF">all the help that I needed</HighlightedText> to get familiar with the TOEFL format. The team was also ready to help, whenever I reached out.<br /><br />The <HighlightedText color="#FCF0BF">tricks and tips given in the lessons</HighlightedText> not only help you to build your skills but also give you <HighlightedText color="#FCF0BF">confidence</HighlightedText> and a positive state of mind which are essential for a high TOEFL score.<br /><br />Overall, in such a short time, Magoosh helped me to get more than my dream score."
          </>
        ),
        image: {
          height: '300px',
          src: AybigeHeadshot,
          width: '340px'
        }
      }}
      quotes={[
        {
          studentName: 'Aryan K.',
          studentAffiliation: null,
          content: (
            <>
              "The platform adapts to your strengths and weaknesses. This feature helped me <HighlightedText color="#FCF0BF">make the most of my study time</HighlightedText>, focusing on the areas where I needed the most improvement."
            </>
          )
        },
        {
          studentName: 'Kathryn C.',
          studentAffiliation: null,
          content: (
            <>
              "The <HighlightedText color="#FCF0BF">teachers would clearly explain their ideas</HighlightedText>, so it doesn't make any trouble for me to understand them in my second language."
            </>
          )
        },
        {
          studentName: 'Pia R.',
          studentAffiliation: null,
          content: (
            <>
              "It really helped me to prepare the exam in <HighlightedText color="#FCF0BF">very little time</HighlightedText>. The <HighlightedText color="#FCF0BF">explanations for each answer</HighlightedText> were the most useful, as it helped me understand what the exam was really looking for."
            </>
          )
        },
        {
          studentName: 'Shruti W.',
          studentAffiliation: null,
          content: (
            <>
              "Magoosh helped me a lot by giving me <HighlightedText color="#FCF0BF">the actual test experience</HighlightedText>. There are a <HighlightedText color="#FCF0BF">lot of questions to practice</HighlightedText> which helps you throughout your learning journey."
            </>
          )
        }
      ]}
    />
  );
};
